// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"ReportAnAbsenceSummary_sectionHeader__3Y24j","link":"ReportAnAbsenceSummary_link__1vOb7"};